import {
	CHANGE_NEW_USER_PROPERTIES,
	LOGOUT,
	RECEIVE_BAD_RESPONSE_POST_NEW_USER,
	RECEIVE_POST_NEW_USER_RESPONSE,
	REQUEST_NEW_USER,
	CLEAR_NEW_USER,
	EDIT_USER,
	REQUEST_EDIT_USER,
	RECEIVE_PATCH_USER_RESPONSE,
	RECEIVE_BAD_RESPONSE_PATCH_USER,
	HANDLE_SUB_CASES_PER_CASE_TYPE,
	UNLOCK_ARAG_USER, UNLOCK_ARAG_USER_SUCCESS, UNLOCK_ARAG_USER_FAILED
} from "../actions/index";
import _ from 'lodash';
import {
  CHANGE_NEW_USER_NEW_PASSWORD_FORM,
  CHANGE_NEW_USER_STORE_SETTINGS,
  CLOSE_CHANGE_PASSWORD_MODAL, CLOSE_DELETE_USER_MODAL,
  DELETE_ARAG_USER, DELETE_ARAG_USER_FAIL, DELETE_ARAG_USER_SUCCESS,
  GET_ARAG_USER_BY_ID_SUCCESS, OPEN_CHANGE_PASSWORD_MODAL, OPEN_DELETE_USER_MODAL,
  RESET_ARAG_USER_PASSWORD,
  RESET_ARAG_USER_PASSWORD_FAIL,
  RESET_ARAG_USER_PASSWORD_SUCCESS
} from "../actions";

const defaultState = {
	userForm: {
		emailInfoAppear: false,
		usernameInfoAppear: false,
		emailValidationError: false,
		usernameValidationError: false
	},
	newUserFormData: {
		id: '',
		username: "",
		forename: "",
		surname: "",
		email: "",
		password: '',
		roles: ["User"],
		level: '',
		group: '',
		caseTypes: {},
        subCases: {},
		subCaseTypes: {},
		damages: {},
        subCasesPerCaseType: {}, //structure is: caseTypeId: {subCases: {damages}}
		allowedToEditOtherApplications: false,
		allowedToEditPremiumSettings: false,
		allowedToEditReferralSettings: false,
		allowedToEditTobas: false,
		allowedToEditArticles: false,
		allowedToCreateInternalAlerts:false,
		disabled: false,

	},
	isNew: true,
	responseMsg:'',
	posting: false,
	badResponse: '',
	successMsg: '',
	requestingResetPassword: false,
	requestResetPasswordFailMessage: '',
	requestResetPasswordSuccessMessage: '',
	deletingAragUser: false,
	deleteAragUserResponseMessage: '',
	changePasswordModalOpen: false,
  	deleteUserModalOpen: false,
	unlockingUser: false,
	unlockErrorMessage: null,
	changePasswordForm: {
		password: '',
		newPassword: '',
		reNewPassword: '',
	}
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case UNLOCK_ARAG_USER:
			return {
				...state,
				unlockingUser: true,
				unlockErrorMessage: null
			};
		case UNLOCK_ARAG_USER_SUCCESS:
			return {
				...state,
				unlockingUser: false,
				unlockErrorMessage: null,
				newUserFormData: {
					...state.newUserFormData,
					isLockedOutUntilUtc: null
				}
			};
		case UNLOCK_ARAG_USER_FAILED:
			let unlockUserErrorMessage = "";
			try {
				unlockUserErrorMessage = action.payload.response.body.message
			} catch (e) {
				unlockUserErrorMessage = "Failed to unlock arag user."
			}
			return {
				...state,
				unlockingUser: false,
				unlockErrorMessage: unlockUserErrorMessage
			};
		case CHANGE_NEW_USER_NEW_PASSWORD_FORM:
            return {
                ...state,
				changePasswordForm: {
					...state.changePasswordForm,
                    [action.payload.key]: action.payload.value
				}
            };
		case CHANGE_NEW_USER_STORE_SETTINGS:
			return {
				...state,
				[action.payload.key]: action.payload.value
			};
		case OPEN_CHANGE_PASSWORD_MODAL:
			return {
				...state,
                changePasswordModalOpen: true
			};
		case CLOSE_CHANGE_PASSWORD_MODAL:
			return {
				...state,
                changePasswordModalOpen: false
			};
		case OPEN_DELETE_USER_MODAL:
			return {
				...state,
				deleteUserModalOpen: true
			};
		case CLOSE_DELETE_USER_MODAL:
			return {
				...state,
        deleteUserModalOpen: false
			};
        case DELETE_ARAG_USER:
			return {
				...state,
                deletingAragUser: true,
                deleteAragUserResponseMessage: defaultState.deleteAragUserResponseMessage
			};
		case DELETE_ARAG_USER_SUCCESS:
			return {
				...state,
                deletingAragUser: false
			};
		case DELETE_ARAG_USER_FAIL:
			let deleteAragUserResponseMsg = '';
			try {
                deleteAragUserResponseMsg = action.payload.response.body.message;
            } catch (e) {
                deleteAragUserResponseMsg = 'Failed to delete user.'
            }
			return {
				...state,
                deletingAragUser: false,
                deleteAragUserResponseMessage: deleteAragUserResponseMsg
			};
		case RESET_ARAG_USER_PASSWORD:
			return {
				...state,
                requestingResetPassword: true,
				requestResetPasswordSuccessMessage: defaultState.requestResetPasswordSuccessMessage,
				requestResetPasswordFailMessage: defaultState.requestResetPasswordFailMessage
			};
		case RESET_ARAG_USER_PASSWORD_SUCCESS:
			return {
				...state,
                requestingResetPassword: false,
                requestResetPasswordSuccessMessage: 'Email sent.'
			};
		case RESET_ARAG_USER_PASSWORD_FAIL:
            let requestResetPasswordFailMsg = '';
            try {
                requestResetPasswordFailMsg = action.payload.response.body.message
            } catch (e) {
                requestResetPasswordFailMsg = 'Failed to reset password.'
            }
			return {
				...state,
                requestingResetPassword: false,
                requestResetPasswordFailMessage: requestResetPasswordFailMsg
			};
		case GET_ARAG_USER_BY_ID_SUCCESS:
			if(!action.payload) return state;
			let groupN ;
			let roles = [];
			let caseT = {};
			let subCaseT = {};
			let dmgs = {};
			_.forEach(action.payload.body.caseTypeDtos, dto => {
				caseT = {...caseT, [dto.id]: dto};
				let o = {};
				_.forEach(dto.subCaseTypes, subDto => {
					o = {...o, [subDto.id]: subDto}
				});
				subCaseT = {...subCaseT, [dto.id]: o}
			});
            _.forEach(action.payload.body.damageDtos, d => {
                dmgs = {...dmgs, [d.id]: d}
            });
			try {
                groupN = action.payload.body.roles[0];
                roles = action.payload.body.roles;
			} catch(e) { groupN = '';}
			return {
				...state,
                isNew: false,
                newUserFormData: {
					...state.newUserFormData,
                    allowedToEditOtherApplications: action.payload.body.allowedToEditOtherApplications,
                    allowedToEditPremiumSettings: action.payload.body.allowedToEditPremiumSettings,
                    allowedToEditReferralSettings: action.payload.body.allowedToEditReferralSettings,
                    allowedToEditTobas: action.payload.body.allowedToEditTobas,
                    allowedToEditArticles: action.payload.body.allowedToEditArticles,
					allowedToCreateInternalAlerts:action.payload.body.allowedToCreateInternalAlerts,
					id: action.payload.body.id,
					username: action.payload.body.username,
					forename: action.payload.body.forename,
					surname: action.payload.body.surname,
					email: action.payload.body.email,
					level: action.payload.body.levelMachineName,
                    disabled: action.payload.body.disabled,
					group: groupN,
					caseTypes: caseT,
					subCases: subCaseT,
					damages: dmgs,
                    roles: roles,
					isLockedOutUntilUtc: action.payload.body.isLockedOutUntilUtc,
				}
			};
        case HANDLE_SUB_CASES_PER_CASE_TYPE:
			return {
				...state,
                newUserFormData: {
					...state.newUserFormData,
                    subCasesPerCaseType: {
                        ...state.newUserFormData.subCasesPerCaseType,
                        [action.payload.caseTypeId]: {
                            subCases: action.payload.value
                        }
                    }
				}
			};
		case EDIT_USER:
			if(!action.payload) return defaultState;
			let damages = {};
			let group;
			try {
				group = action.payload.roles[0]
			}
			catch (e){ group = '' }
			if(action.payload.damageDtos){
				_.forEach(action.payload.damageDtos , d => {
					damages.push({[d.id]: d})
				})
			}
			let caseTypes = {};
			let subCasesPerCaseType = {};
			if(action.payload.caseTypeDtos){
                _.forEach(action.payload.caseTypeDtos , c => {
                    caseTypes = {
                    	...caseTypes,
						[c.id]: c
                    };
                    subCasesPerCaseType = {
                        ...subCasesPerCaseType,
                        [c.id]: c.subCaseTypes
                    };
                })
			}
			return {
				...state,
				isNew: false,
				newUserFormData: {
					...state.newUserFormData,
					id: action.payload.id,
					username: action.payload.username,
					forename: action.payload.forename,
					surname: action.payload.surname,
					email: action.payload.email,
					password: action.payload.password,

                    allowedToEditArticles: action.payload.allowedToEditArticles,
                    allowedToEditOtherApplications: action.payload.allowedToEditOtherApplications,
                    allowedToEditPremiumSettings: action.payload.allowedToEditPremiumSettings,
                    allowedToEditReferralSettings: action.payload.allowedToEditReferralSettings,
                    allowedToEditTobas: action.payload.allowedToEditTobas,
					damages: damages,
					level: action.payload.levelMachineName,
					group: group,
					caseTypes: caseTypes,
					subCasesPerCaseType: subCasesPerCaseType
				},

			};
		case REQUEST_EDIT_USER:
			return {
				...state,
				posting: true,
				successMsg: '',
				responseMsg: '',
                changePasswordModalOpen: false,

            };
		case RECEIVE_PATCH_USER_RESPONSE:
			return {
				...state,
				posting: false,
				successMsg: 'User updated successfully.'
			};
		case RECEIVE_BAD_RESPONSE_PATCH_USER:
			return {
				...state,
				posting: false,
				successMsg: '',
				badResponse: action.payload,
			};
		case CHANGE_NEW_USER_PROPERTIES:
			if(action.payload.key === 'badResponse'){
				return {
					...state,
                    badResponse: action.payload.value
				}
			}
			return {
				...state,
				badResponse: '',
				newUserFormData: {...state.newUserFormData, [action.payload.key]: action.payload.value},
				responseMsg: '',
				successMsg: '',
				userForm: {...state.userForm, emailValidationError:false, usernameValidationError:false},
				requestResetPasswordSuccessMessage: defaultState.requestResetPasswordSuccessMessage,
				requestResetPasswordFailMessage: defaultState.requestResetPasswordFailMessage
			};
		case REQUEST_NEW_USER:
			return {
				...state,
				posting: true,
				successMsg: '',
				responseMsg: ''
			};
		case RECEIVE_BAD_RESPONSE_POST_NEW_USER:
			if (action.payload === 'Email is already taken')
				return {
					...state,
					posting:false,
					badResponse: action.payload,
					userForm: {...state.userForm, emailValidationError:true},
					successMsg: ''
				};
			else if(action.payload === 'Username is already taken'){
				return {
					...state,
					posting:false,
					badResponse: action.payload,
					userForm: {...state.userForm, usernameValidationError:true},
					successMsg: ''
				};
			}
			else if(action.payload === 'Username and Email are already taken'){
				return {
					...state,
					posting:false,
					badResponse: action.payload,
					userForm: {...state.userForm, usernameValidationError:true, emailValidationError:true},
					successMsg: ''
				};
			}
			else
				return {
					...state,
					posting:false,
					badResponse: action.payload,
					userForm: {...state.userForm, emailValidationError:false, usernameValidationError:false},
					successMsg: ''
				};
		case RECEIVE_POST_NEW_USER_RESPONSE:
			return {
				...state,
				posting:false,
				newUserFormData: defaultState.newUserFormData,
				successMsg: 'New user was created Successfully',
				userForm: {...state.userForm, emailValidationError:false, usernameValidationError:false}
			};
		case CLEAR_NEW_USER:
			return {
				...state,
				posting:false,
				newUserFormData: defaultState.newUserFormData,
				userForm: {...state.userForm, emailValidationError:false, usernameValidationError:false},
				successMsg: '',
				responseMsg: '',
				badResponse: '',
				isNew: true
			};
		case LOGOUT:
			return {
				...defaultState
			};
		case "@@router/LOCATION_CHANGE":
			if(action.payload.location.pathname !== "/users/edit-user") {
				return {
					...defaultState
				};
			}else{
				return{
					...state,
                    deleteAragUserResponseMessage: defaultState.deleteAragUserResponseMessage
				}
			}
		default :
			return state
	}
}